export default __webpack_public_path__ + "static/media/fabric_io.f9c1cd54.svg";